import React from 'react';

import type { UserImage } from '../../shop-builder/types';
import type { Endorsement } from '../types';
import { Drawer } from './Drawer';
import './EndorsementsDrawer.css';

interface EndorsementsDrawerProps {
    endorsements: Endorsement[];
    athleteImage: UserImage | null;
}

function pickProfileSrc(image: UserImage | null): string | null {
    if (!image) { return null; }
    return image.webp?.['320'] || image.jpeg?.['320'] || image.webp?.['640'] || image.jpeg?.['640'] || null;
}

export function EndorsementsDrawer({ endorsements, athleteImage }: EndorsementsDrawerProps) {
    if (endorsements.length === 0) { return null; }

    const profileSrc = pickProfileSrc(athleteImage);

    return (
        <Drawer label="endorsements" defaultOpen>
            <div className="pdp-endorsements__list">
                {endorsements.map((e) => (
                    <article key={e.variant_id} className="pdp-endorsement-card">
                        <header className="pdp-endorsement-card__head">
                            <span className="pdp-endorsement-card__thumb" aria-hidden={!profileSrc}>
                                {profileSrc ? (
                                    athleteImage?.srcsets ? (
                                        <picture>
                                            <source srcSet={athleteImage.srcsets.avif} type="image/avif" />
                                            <source srcSet={athleteImage.srcsets.webp} type="image/webp" />
                                            <img src={profileSrc} alt={e.athlete_name || ''} loading="lazy" />
                                        </picture>
                                    ) : (
                                        <img src={profileSrc} alt={e.athlete_name || ''} loading="lazy" />
                                    )
                                ) : null}
                            </span>
                            {e.athlete_name && (
                                <p className="pdp-endorsement-card__name">{e.athlete_name}</p>
                            )}
                        </header>
                        <p className="pdp-endorsement-card__quote">&ldquo;{e.endorsement_text}&rdquo;</p>
                    </article>
                ))}
            </div>
        </Drawer>
    );
}
